import { store } from '@/store';
import StickyAlert from '@/modules/alerts/models/sticky-alert';
import useStickyAlerts from '@/modules/alerts/composables/useStickyAlerts';
import WebCartUser from '@/models/entities/user/webCartUser';
import { STICKY_ALERT_TYPE } from '@/modules/alerts/models/sticky-alert-type';
import BasicStickyAlertProps, {
  BASIC_STICKY_ALERT_TYPE,
} from '@/modules/alerts/models/basic-sticky-alert-props';

const { addAlert } = useStickyAlerts();

export default async function requireReauthentication(to, from, next) {
  const user: WebCartUser = store.getters['user/getUser'];
  const isAuthenticated = store.getters['user/isCustomer'];

  const authInLastMinute = isAuthenticated && user?.iat && Date.now() - user.iat * 1000 <= 60000;
  if (authInLastMinute) {
    next();
  } else if (!isAuthenticated) {
    const alert = new StickyAlert(
      STICKY_ALERT_TYPE.BASIC,
      new BasicStickyAlertProps(BASIC_STICKY_ALERT_TYPE.WARNING, "You'll need to login first", {
        timeoutMs: 7000,
      }),
    );
    addAlert(alert);
    next({ name: 'Login', query: { redirectTo: to.fullPath } });
  } else {
    next({ name: 'Reauthenticate', query: { redirectTo: to.fullPath, redirectName: to.name } });
  }
}
